import React, { useState, useEffect } from "react";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import "./TableIncomeAndExpenses.css";
import { BsCardList } from "react-icons/bs";
import axios from "axios";
import Swal from "sweetalert2";

const TableIncomeAndExpenses = ({ data, reloadData }) => {
  const [incomeAndExpensesData, setIncomeAndExpensesData] = useState([]);
  const [incomeAndExpenseTotal, setIncomeAndExpenseTotal] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const userId = data && data.id ? data.id : null;
  useEffect(() => {
    if (userId !== null) {
      // Construye la URL de la solicitud GET con el ID del usuario y las fechas
      const apiUrl = `${process.env.REACT_APP_INCOME_AND_EXPENSES}?userId=${userId}`;

      // Realiza la solicitud GET al backend para obtener los datos de ingresos y egresos
      const fetchData = async () => {
        try {
          const response = await axios.get(apiUrl);
          if (response.status === 204) {
            // Actualizar el estado de ingresos y egresos a un arreglo vacío
            setIncomeAndExpensesData([]);
            setIncomeAndExpenseTotal([]);
          } else {
            setIncomeAndExpensesData(response.data.userIncomeAndExpenses);
            setIncomeAndExpenseTotal(response.data.userTotal.totalBalance);
          }
        } catch (error) {
          setIncomeAndExpensesData([]);
          setIncomeAndExpenseTotal([]);
        }
      };

      // Llama a la función fetchData cuando el componente se monta
      fetchData();
    }
  }, [data, userId, reloadData]);

  const handleFilterButtonClick = () => {
    if (userId !== null) {
      // Realiza la solicitud GET al backend cuando se hace clic en el botón de filtro
      const apiUrl = `${process.env.REACT_APP_INCOME_AND_EXPENSES}?userId=${userId}&from=${fromDate}&to=${toDate}`;

      const fetchData = async () => {
        try {
          const response = await axios.get(apiUrl);
          setIncomeAndExpensesData(response.data.userIncomeAndExpenses);
          setIncomeAndExpenseTotal(response.data.userTotal);
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo un error al intentar cargar los Pagos/Cobros del usuario.",
          });
        }
      };

      fetchData();
    }
  };

  return (
    <div className="all_newig_eg2">
      <h2 className="tittle_ig_eg">Todos los Pagos y Cobros</h2>
      <div className="flexdateinputig_eg">
        <div className="collumndate_ig_eg">
          <label htmlFor="fromDate" className="label_ig_eg">
            Fecha de inicio
          </label>
          <input
            className="inputdate_ig_eg"
            type="date"
            id="fromDate"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="collumndate_ig_eg">
          <label htmlFor="toDate" className="label_ig_eg">
            Fecha de finalizacion
          </label>
          <input
            className="inputdate_ig_eg"
            type="date"
            id="toDate"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <button
          className="button_date_search_ig_eg"
          onClick={handleFilterButtonClick}
        >
          Filtrar
        </button>
      </div>
      {incomeAndExpensesData.length === 0 ? (
        <NotReportViewData
          title="Lo sentimos pero no hay Pagos ni Cobros que mostrar"
          Icon={BsCardList}
        />
      ) : (
        <>
          <div className="list_reports_ig_eg2">
            <h2 className="tittle_ig_eg">Todos los Pagos y Cobros</h2>
            <div className="scrool_ig_eg">
              {incomeAndExpensesData.map((item, index) => (
                <div className="reports_ig_eg" key={index}>
                  <div className="width_ig_ig_eg first_three">
                    <p className="ig_eg_p_data">{item.incomeAndExpenses}</p>
                  </div>
                  <div className="width_ig_ig_eg first_three">
                    <p className="ig_eg_p_data">{item.createAt}</p>
                  </div>
                  <div className="width_ig_ig_eg first_three">
                    <p className="ig_eg_p_data">{"$" + item.amount}</p>
                  </div>
                  <div className="width_ig_ig_eg">
                    <p className="ig_eg_p_data">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="total_ig_eg">
              <div className="ig_eg_total">
                <p className="ig_eg_p_data">
                  Monto Total: {incomeAndExpenseTotal}
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TableIncomeAndExpenses;
